import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Download, Wallet, FileText, Lock } from "lucide-react";

const MONTH_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export default function PortalSalary() {
  const [slips, setSlips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/my-portal/payslips");
        setSlips(data || []);
      } catch (e) {
        toast.error(formatApiErrorDetail(e.response?.data?.detail));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const monthLabel = (m) => {
    if (!m) return "—";
    const d = new Date(m);
    return `${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`;
  };

  return (
    <div className="space-y-6" data-testid="portal-salary">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-slate-400">Salary</div>
        <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: "Chivo" }}>
          Salary Slips
        </h1>
        <p className="text-sm text-slate-500 mt-1 flex items-center gap-1.5">
          <Lock className="h-3.5 w-3.5" /> Amounts are only visible inside the downloaded PDF — password: your Date of Birth (DDMMYY).
        </p>
      </div>

      {loading ? (
        <div className="text-sm text-slate-500">Loading...</div>
      ) : slips.length === 0 ? (
        <div className="bg-white rounded-xl border border-red-100 p-8 text-center">
          <Wallet className="h-10 w-10 mx-auto mb-3 text-slate-300" />
          <div className="text-sm text-slate-600 font-medium">No payslips yet</div>
          <div className="text-xs text-slate-500 mt-1">
            Your monthly payslips will appear here after HR finalises payroll.
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-red-100 overflow-hidden">
          <table className="w-full text-sm" data-testid="payslips-table">
            <thead className="bg-red-50/50 text-[11px] uppercase tracking-wider text-slate-500">
              <tr>
                <th className="text-left px-4 py-3">Month</th>
                <th className="text-right px-4 py-3">Download</th>
              </tr>
            </thead>
            <tbody>
              {slips.map((s) => (
                <tr key={s.id} className="border-t border-red-50" data-testid={`payslip-row-${s.id}`}>
                  <td className="px-4 py-3 font-semibold text-slate-900 flex items-center gap-2">
                    <FileText className="h-4 w-4 brand-text" />
                    {monthLabel(s.month)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <a
                      href={`/api/my-portal/payslips/${s.id}/pdf`}
                      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md brand-bg brand-bg-hover text-white text-xs font-medium"
                      data-testid={`payslip-download-${s.id}`}
                    >
                      <Download className="h-3.5 w-3.5" /> PDF
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
